
import { useNavigate } from 'react-router';
import { ReactNode, useEffect } from 'react';

import { useGetAppContext } from '@/services/context/queries';

export function RegisterRedirectGate({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const { data: appContext } = useGetAppContext();

  useEffect(() => {
    if (!appContext) return;
    if (appContext.user.emailVerified) {
      navigate('/dashboard', { replace: true });
    } else {
      navigate('/register/thank-you', { replace: true });
    }
  }, [appContext, navigate]);

  return <>{children}</>;
}
